import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/t_logo.png'
import _imports_1 from '../assets/icon1.png'
import _imports_2 from '../assets/icon4.png'
import _imports_3 from '../assets/icon5.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row bg-dange text-center justify-content-center" }
const _hoisted_3 = { class: "fs-3" }
const _hoisted_4 = { class: "card card-body text-center shadow" }
const _hoisted_5 = { class: "fs-3" }
const _hoisted_6 = { class: "fs-3" }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "d-flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row d-flex justify-content-center mt-3" }, [
      _createElementVNode("img", {
        alt: "Vue logo",
        src: _imports_0,
        class: "mt-2 text-center",
        style: {"max-width":"300px"}
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "お名前：" + _toDisplayString(_ctx.userInfo?.userName) + "　様", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue_qrcode, {
        value: _ctx.userInfo.userId,
        options: _ctx.qrOption,
        class: "qr-code align-self-center"
      }, null, 8, ["value", "options"]),
      _createElementVNode("span", _hoisted_5, _toDisplayString((_ctx.userInfo.userId as string).substring(0, 8)), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString((_ctx.userInfo.userId as string).substring(8)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "p-3 card card-body me-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.move('/exam')))
        }, [...(_cache[3] || (_cache[3] = [
          _createStaticVNode("<div class=\"align-self-center\" data-v-7c131ab5><div class=\"text-center\" data-v-7c131ab5><img alt=\"Vue logo\" src=\"" + _imports_1 + "\" class=\"mt-2\" style=\"width:70%;\" data-v-7c131ab5></div><div class=\"text-center\" data-v-7c131ab5><span class=\"h3\" data-v-7c131ab5>健診結果</span></div></div>", 1)
        ]))]),
        _createElementVNode("div", {
          class: "p-3 card card-body ms-2 me-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.move('/settings')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", null, [
            _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("img", {
                alt: "Vue logo",
                src: _imports_2,
                class: "mt-2",
                style: {"width":"50%"}
              })
            ]),
            _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("span", { class: "h3" }, "設定")
            ])
          ], -1)
        ]))]),
        _createElementVNode("div", {
          class: "p-3 card card-body ms-2 shadow flex-item d-flex flex-column justify-content-around",
          style: {"cursor":"pointer"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.move('/logout')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", null, [
            _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("img", {
                alt: "Vue logo",
                src: _imports_3,
                class: "mt-2",
                style: {"width":"50%"}
              })
            ]),
            _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("span", { class: "h5" }, "ログアウト")
            ])
          ], -1)
        ]))])
      ])
    ])
  ]))
}